import * as React from "react";
import { Modal } from "antd";
import { CURRENT_VERSION } from "@/config/const";

interface aboutModalProps {
  visible: boolean;
  afterClose: () => void;
}

const AboutModal: React.FC<aboutModalProps> = ({ visible, afterClose }) => {
  return (
    <Modal
      title="关于"
      footer={null}
      width={300}
      onCancel={afterClose}
      visible={visible}
      centered
    >
      <p>视频会议 {CURRENT_VERSION}</p>
    </Modal>
  );
};

export default AboutModal;
